const states = {
    intent_details: {
        intents: [],
        active_intent_data:{},
        loaders: {
            intents_loading: false,
            intents_loaded: false,
            intent_data_loading: false,
            intent_data_loaded: false,
            intent_creating: false,
        }
    },
};

export default states;


// WEBPACK FOOTER //
// ./src/data/redux/intent_details/states.js